import { render } from "./BannerSplit.vue?vue&type=template&id=d0fb2c12&scoped=true"
import script from "./BannerSplit.vue?vue&type=script&lang=js"
export * from "./BannerSplit.vue?vue&type=script&lang=js"

import "./BannerSplit.vue?vue&type=style&index=0&id=d0fb2c12&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0fb2c12"]])

export default __exports__